import classNames from 'classnames';
import { Page } from 'components/atoms';
import React, { FC } from 'react';
import { useDeviceClassification } from 'utils';
import styles from "../Subpage.module.css";

type TSimplifiedBannerDesktopProps = {
    HeroSectionTitle: string;
    HeroSectionSuperscript: string;
    ShowQuickFactsSidebar: boolean;
}

export const SimplifiedBannerDesktop: FC<TSimplifiedBannerDesktopProps> = ({
    HeroSectionSuperscript,
    HeroSectionTitle,
    ShowQuickFactsSidebar
}) => {
    const { isDesktop } = useDeviceClassification();
    
    return (
        <Page className={"pb-0 pt-0"}>
            <div
                className={classNames(styles.simplifiedBannerWrapper, isDesktop ? 'col-8' : 'col-12', { 'm-auto' : !ShowQuickFactsSidebar } )}
                style={{ paddingTop: '107px' }}>
                <h1 className="mb-0">
                    <span dangerouslySetInnerHTML={{ __html: HeroSectionSuperscript }} />
                    <em dangerouslySetInnerHTML={{ __html: HeroSectionTitle }} />
                </h1>
            </div>
        </Page>
    )
}
